import { Money } from "shared/types";
import { toMoney } from "shared/utils";

export const KeyValue = ({
  label,
  value
}: {
  label: string;
  value: string | number | Money | React.ReactNode;
}) => {
  return (
    <div className="flex gap-1 text-sm font-medium">
      <span className="text-content-300 max-w-[180px] w-full">{label}</span>
      <span className="text-content-1000">
        {value && typeof value === "object" && "cents" in value
          ? toMoney(value.cents / 100)
          : value || "-"}
      </span>
    </div>
  );
};
